/* eslint-disable no-unused-vars */
import { curry } from 'lib/util'
import concatQueryParams from 'app/_shared/events/search/query/util'

/**
 * Sets the `query` parameter for the current search to only include items that are of the specified
 * doc type.
 *
 * @param {Gaia.AppModule.Spec} module      app module
 * @param {Gaia.Component.Spec} component   action component
 * @param {Event|object} event              information about the event that triggered this handler
 * @returns {string}
 */
const isDeviceOrEquipmentOrContactOrOrganisation = (module, component, event) => {
  const params = {
    type: 'metatype:serviceitem OR metaype:equipment OR metatype:person OR metatype:organisation OR metatype:request',
  }

  return concatQueryParams(params)
}

export default curry(isDeviceOrEquipmentOrContactOrOrganisation)
